
export const APP_NAME = "Watchflow"

export const BASE_URL = "https://watchflow.onrender.com"
